var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "b-row",
    [
      _c(
        "b-col",
        { attrs: { cols: "12", md: "6" } },
        [
          _c(
            "b-row",
            { staticClass: "mb-2" },
            [
              _c(
                "b-col",
                { staticClass: "mb-1", attrs: { cols: "12" } },
                [
                  _c("b-skeleton", {
                    attrs: { animation: "fade", width: "20%" },
                  }),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "b-col",
                { attrs: { cols: "5" } },
                [
                  _c("b-skeleton", {
                    attrs: { animation: "fade", width: "100%", height: "2rem" },
                  }),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "b-col",
                { attrs: { cols: "5" } },
                [
                  _c("b-skeleton", {
                    attrs: { animation: "fade", width: "100%", height: "2rem" },
                  }),
                ],
                1
              ),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "b-row",
            { staticClass: "mb-2" },
            [
              _c(
                "b-col",
                { staticClass: "mb-1", attrs: { cols: "12" } },
                [
                  _c("b-skeleton", {
                    attrs: { animation: "fade", width: "20%" },
                  }),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "b-col",
                { staticClass: "d-flex", attrs: { cols: "10" } },
                [
                  _c("b-skeleton", {
                    attrs: { animation: "fade", width: "100%", height: "2rem" },
                  }),
                ],
                1
              ),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "b-row",
            { staticClass: "mb-2" },
            [
              _c(
                "b-col",
                { staticClass: "mb-1", attrs: { cols: "12" } },
                [
                  _c("b-skeleton", {
                    attrs: { animation: "fade", width: "20%" },
                  }),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "b-col",
                { staticClass: "d-flex", attrs: { cols: "10" } },
                [
                  _c("b-skeleton", {
                    attrs: { animation: "fade", width: "100%", height: "2rem" },
                  }),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "b-col",
        { attrs: { cols: "12", md: "6" } },
        [
          _c(
            "b-row",
            { staticClass: "mb-2" },
            [
              _c(
                "b-col",
                { staticClass: "mb-1", attrs: { cols: "12" } },
                [
                  _c("b-skeleton", {
                    attrs: { animation: "fade", width: "20%" },
                  }),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "b-col",
                { staticClass: "d-flex", attrs: { cols: "10" } },
                [
                  _c("b-skeleton", {
                    attrs: { animation: "fade", width: "100%", height: "2rem" },
                  }),
                ],
                1
              ),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "b-row",
            { staticClass: "mb-2" },
            [
              _c(
                "b-col",
                { staticClass: "mb-1", attrs: { cols: "12" } },
                [
                  _c("b-skeleton", {
                    attrs: { animation: "fade", width: "20%" },
                  }),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "b-col",
                { staticClass: "d-flex", attrs: { cols: "10" } },
                [
                  _c("b-skeleton", {
                    attrs: { animation: "fade", width: "100%", height: "2rem" },
                  }),
                ],
                1
              ),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "b-row",
            { staticClass: "mb-2" },
            [
              _c(
                "b-col",
                { staticClass: "mb-1", attrs: { cols: "12" } },
                [
                  _c("b-skeleton", {
                    attrs: { animation: "fade", width: "20%" },
                  }),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "b-col",
                { staticClass: "d-flex", attrs: { cols: "10" } },
                [
                  _c("b-skeleton", {
                    attrs: { animation: "fade", width: "100%", height: "2rem" },
                  }),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "b-col",
        { staticClass: "mt-4", attrs: { cols: "12" } },
        [_c("b-skeleton", { attrs: { animation: "fade", width: "40%" } })],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }